module.exports = __webpack_public_path__ + "img/jhs_Android.ab61c4cb.png";